// extracted by mini-css-extract-plugin
module.exports = {"description":"ModalDescription_description__3plbM","small":"ModalDescription_small__3FARN"};